import { Component } from 'react';
import styled from 'styled-components';

import { Message, MessageTitle, MessageDescription } from '@yj-intl/riff-react';

const StyledMessage = styled(Message)`
  width: auto;
  margin: 12px 16px;
  word-break: break-all; /* URLなどの英数字の羅列が突き抜けないようにする */
`;

type InformationVariant = 'information' | 'success' | 'warning' | 'alert';
interface IProps {
  isShow: boolean;
  variant: InformationVariant;
  title?: string;
  text?: string;
  linkURL?: string;
  linkText?: string;
  dataClParams?: string;
  hasBorder: boolean; // モジュールの枠線を付ける。基本はボーダー無しだが、視認性を担保したい場合に使う。
}

interface IDefaultProps {
  hasBorder: boolean;
}
export default class Information extends Component<IProps> {
  public static defaultProps: IDefaultProps = {
    hasBorder: false
  };

  /**
   *
   */
  public render() {
    return this.props.isShow ? (
      <StyledMessage border={this.props.hasBorder} variant={this.props.variant}>
        {this.props.title ? <MessageTitle>{this.props.title}</MessageTitle> : null}
        {this.props.text || (this.props.linkURL && this.props.linkText) ? (
          <MessageDescription whiteSpace="pre-line">
            {this.props.text}
            {/* テキストが無い場合は、改行しない。※propsごと無い場合と空の値が入って来る場合がある。 */}
            {this.props.text === '' || !this.props.text ? null : <br />}
            {this.props.linkURL && this.props.linkText ? (
              <a href={this.props.linkURL} data-cl-params={this.props.dataClParams}>
                {this.props.linkText}
              </a>
            ) : null}
          </MessageDescription>
        ) : null}
      </StyledMessage>
    ) : null;
  }
}
